import { FC } from "react";
import classNames from "classnames";
import { format } from "date-fns";

import { CustomTooltipProps } from "./types";
import { ArrawRightIcon, EyeIcon, TrophyIcon } from "../../../icons";
import Button from "../../../Button/Button";
import { ChartSeriesKey } from "../../types";
import { getSentimentIcon } from "../../../../utils/getSentimentIcon";

import styles from "./CustomTooltip.module.css";



const CustomTooltip: FC<CustomTooltipProps> = ({ tooltip, tooltipRef, closeTimeoutRef, setTooltip, setActiveDotPayload, onClickTooltip, visibleSeries }) => {
  const formattedDate = format(new Date(tooltip.payload.created_at), 'dd MMM, yyyy');
  const SentimentIcon = getSentimentIcon(tooltip.payload.sentiment);

  const onMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
  }

  const onMouseLeave = () => {
    setTooltip(null);
    setActiveDotPayload(null);
  }

  const handleClick = () => {
    onClickTooltip(tooltip.payload.created_at);
  }



  return (
    <div 
      ref={tooltipRef}
      style={{
        position: 'absolute',
        left: tooltip.x - 110,
        top: tooltip.y - 110,
      }}
      className={styles.tooltip__container + ' ' + styles[`tooltip__container--${tooltip.type}`]}
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <section
        className={styles.tooltip}
      >
        <div className={styles.tooltip__content}>

          <div className={classNames(
            styles.tooltip__value, 
            styles['is-visibility'],
            { [styles['is-disabled']]: !visibleSeries[ChartSeriesKey.Visibility] }
          )}>
            <p>{tooltip.payload.visibility}</p>
            <EyeIcon/>
          </div>
          <div className={classNames(
            styles.tooltip__value, 
            styles['is-sentiment'],
            { [styles['is-disabled']]: !visibleSeries[ChartSeriesKey.Sentiment] }
          )}>
            <p>{tooltip.payload.sentiment}</p>
            <SentimentIcon />
          </div>
          <div className={classNames(
            styles.tooltip__value, 
            styles['is-ranking'],
            { [styles['is-disabled']]: !visibleSeries[ChartSeriesKey.Ranking] }
          )}>
            <p>{tooltip.payload.ranking}</p>
            <TrophyIcon/>
          </div>
        </div>
        <footer className={styles.tooltip__footer}>
          <time className={styles.tooltip__date}>{formattedDate}</time>
          <Button typeStyle="round-outline" Icon={ArrawRightIcon} size="sm" onClick={handleClick} />
        </footer>
      </section>
    </div>
  );
}

export default CustomTooltip;
